import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Fab, Grid, IconButton, InputBase, Paper, Typography, TablePagination } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from "@material-ui/icons/Add";
import { ListaCuotas } from './ListaCuotas';
import { ModalAltaCuota } from './ModalAltaCuota';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { CUOTASFACTURACION_PERMISOS } from '../../../../utils/permisos';
import { fetchCuotas, fetchCuotasPorDescripcion } from '../../../../actions/facturacion/cuotas';
import { Cuota } from './Cuota';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 5,
        flexGrow: 1,
        marginTop:10,
    },
    card:{
        padding:20
    },
    paper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
      },
    input: {
        padding: 10,
    },
    grid: {
        backgroundColor: theme.palette.background.paper,
    },
    formControl: {
        marginTop: 5,
        minWidth: 120,
        marginLeft: 20,
        margin: theme.spacing(1),
    }, 
    button: {
        marginLeft: 25,
    },
    buttonOk:{
        marginLeft: 25
    }
}));

export const HomeCuotas = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { items, cargada, seleccionado } = useSelector((state) => state.cuotas);
    const { permisos: permisosUser } = useSelector(state => state.auth)
    const [textoBuscado, setTextoBuscado] = useState("");
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = () => {
        doSearch();
      }
  
    const handleChange = (e) => {
        setTextoBuscado( e.target.value );
    }

    const handleKeyPress = e => {
        if (e.which === 13) {
            e.preventDefault();
            doSearch();
        }
    }

    const doSearch = () => {
    if(textoBuscado!=="")
        dispatch( fetchCuotasPorDescripcion(textoBuscado) );
    else
        dispatch( fetchCuotas() );
    }

    useEffect(() => {
        dispatch( fetchCuotas() );
    }, [dispatch]);

    return ( 
        <>
            <div className={classes.root}>
                <Grid container justify="center" spacing={1} >
                    <Grid item xs={6} >
                        <Grid item container>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={8}>
                                <Card className={classes.card}>  
                                    <Typography><strong>Buscar Cuotas</strong></Typography>
                                    <Paper component="form" className={classes.paper}>
                                    <InputBase
                                        className={classes.input}
                                        placeholder="Descripcion"
                                        fullWidth={true}
                                        onChange={handleChange}
                                        onKeyPress={handleKeyPress}
                                    />
                                    <IconButton onClick={handleSearch} className={classes.iconButton} aria-label="search">
                                        <SearchIcon />
                                    </IconButton>
                                    </Paper>
                                </Card>
                            </Grid>
                            <Grid item>
                                <ModalAltaCuota open={open} setOpen={setOpen} title={'Alta Nueva Cuota'} />
                                <Fab
                                    className={classes.buttonOk}
                                    color="secondary"
                                    aria-label="add"
                                    size="medium"
                                    disabled={!validarSoloUnPermiso(permisosUser, CUOTASFACTURACION_PERMISOS.ALTA)}
                                    onClick={() => setOpen(true)}
                                >
                                    <AddIcon />
                                </Fab>
                            </Grid>
                            <Grid item xs={2}></Grid>
                        </Grid>                        
                    </Grid>
                    {!seleccionado&& 
                            <>
                                <Grid item xs={10} >
                                    <ListaCuotas
                                        page={page}
                                        items={items} 
                                        cargada={cargada}
                                        rowsPerPage={rowsPerPage}
                                        permisosUser={permisosUser}
                                    />
                                </Grid>
                                <Grid item xs={10} >
                                    {cargada&& items.length > 0&&
                                        <TablePagination
                                            style={{backgroundColor: 'white'}}
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={items.length}
                                            rowsPerPage={rowsPerPage}
                                            labelRowsPerPage='Registros por página'
                                            page={page}
                                            onChangePage={handleChangePage}
                                            onChangeRowsPerPage={handleChangeRowsPerPage}
                                        />
                                    }
                                </Grid>
                            </>
                    }
                </Grid>
                {seleccionado&& 
                    <Cuota />
                }
            </div>
        </>
     );
}